function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_927",
  "data-name": "Group 927",
  transform: "translate(-1299.156 -34.164)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_444",
  "data-name": "Group 444",
  transform: "translate(48.665 -174.336)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_343",
  "data-name": "Group 343",
  transform: "translate(1250.491 208.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_100",
  "data-name": "Ellipse 100",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14.519,
  cy: 14.519,
  r: 14.519,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.519,
  cy: 14.519,
  r: 13.619,
  fill: "none"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_921",
  "data-name": "Group 921",
  transform: "translate(-1.128 -1.428)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_463",
  "data-name": "Path 463",
  d: "M1313.5,45.513v9.033",
  transform: "translate(1.128 0)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_464",
  "data-name": "Path 464",
  d: "M0,0V9.033",
  transform: "translate(1319.144 50.029) rotate(90)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
})));

var SvgInviteFriends = function SvgInviteFriends(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.038,
    height: 29.038,
    viewBox: "0 0 29.038 29.038",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteFriends, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invite-friends.14292851.svg";
export { ForwardRef as ReactComponent };